import { createVNode } from "inferno";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Component } from 'inferno';
import { inject } from 'table-js/lib/components';

var EditableHitPolicyCell =
/*#__PURE__*/
function (_Component) {
  _inherits(EditableHitPolicyCell, _Component);

  function EditableHitPolicyCell(props, context) {
    var _this;

    _classCallCheck(this, EditableHitPolicyCell);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EditableHitPolicyCell).call(this, props, context));

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      _this.eventBus.fire('hitPolicy.edit', {
        event: event
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onElementsChanged", function () {
      _this.forceUpdate();
    });

    inject(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(EditableHitPolicyCell, [{
    key: "getRoot",
    value: function getRoot() {
      return this.sheet.getRoot();
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this.changeSupport.onElementsChanged(this.getRoot().id, this.onElementsChanged);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.changeSupport.offElementsChanged(this.getRoot().id, this.onElementsChanged);
    }
  }, {
    key: "render",
    value: function render() {
      var root = this.getRoot(),
          businessObject = root.businessObject,
          hitPolicy = businessObject.hitPolicy,
          hitPolicyLabel = hitPolicy.charAt(0),
          aggregation = businessObject.aggregation;
      var aggregationLabel = getAggregationLabel(aggregation);
      return createVNode(1, "th", "hit-policy header", [hitPolicyLabel, aggregationLabel], 0, {
        "data-hit-policy": "true",
        "title": 'Hit Policy = ' + hitPolicy,
        "onClick": this.onClick,
        "rowspan": "3"
      });
    }
  }]);

  return EditableHitPolicyCell;
}(Component);

export { EditableHitPolicyCell as default };
EditableHitPolicyCell.$inject = ['changeSupport', 'sheet', 'eventBus']; // helpers //////////////////////

function getAggregationLabel(aggregation) {
  switch (aggregation) {
    case 'SUM':
      return '+';

    case 'MIN':
      return '<';

    case 'MAX':
      return '>';

    case 'COUNT':
      return '#';

    default:
      return '';
  }
}
//# sourceMappingURL=EditableHitPolicyCell.js.map